// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher__FmFF80BjKvI5V","item":"item__2cdNxtymY3jcA","itemInner":"itemInner__0AL68pF2ESvrL","active":"active__55cmq9fKN5xCF","name":"name__BLbXpRlFkYtMh"};